<template>
  <div>
    <b-form-group :label="passwordLabel" label-cols-sm="4" label-align-sm="right">
      <b-input-group>
        <b-input
          :type="visible ? 'text' : 'password'"
          :value="password"
          @input="$emit('update:password', $event)"
          :state="passwordState"
          :placeholder="passwordPlaceholder"
        />
        <b-input-group-addon>
          <b-button size="sm" @click="visible = !visible" tabindex="-1">
            <b-icon :icon="visible ? 'eye' : 'eye-slash'" />
          </b-button>
        </b-input-group-addon>
        <b-form-invalid-feedback>{{ passwordFeedback }}</b-form-invalid-feedback>
      </b-input-group>
    </b-form-group>

    <b-form-group :label="confirmLabel" label-cols-sm="4" label-align-sm="right">
      <b-input-group>
        <b-input
          :type="visible ? 'text' : 'password'"
          :value="confirm"
          @input="$emit('update:confirm', $event)"
          :state="confirmState"
          :placeholder="confirmPlaceholder"
        />
        <b-input-group-addon>
          <b-button size="sm" @click="visible = !visible" tabindex="-1">
            <b-icon :icon="visible ? 'eye' : 'eye-slash'" />
          </b-button>
        </b-input-group-addon>
        <b-form-invalid-feedback>Passwords do not match</b-form-invalid-feedback>
      </b-input-group>
    </b-form-group>

    <b-form-group v-if="(password || '').trim().length > 0" label="" label-cols-sm="4" class="mb-2">
      <password-requirements :value="(password || '').trim()" />
    </b-form-group>
  </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import PasswordRequirements from '@/components/PasswordRequirements';

@Component({ components: { PasswordRequirements } })
export default class PasswordAndConfirmFields extends Vue {
  @Prop({ type: String, default: '' }) password;
  @Prop({ type: String, default: '' }) confirm;
  @Prop({ default: null }) passwordState;
  @Prop({ default: null }) confirmState;
  @Prop({ type: String, default: '' }) passwordFeedback;
  @Prop({ type: String, default: 'Password:' }) passwordLabel;
  @Prop({ type: String, default: 'Confirm Password:' }) confirmLabel;
  @Prop({ type: String, default: 'Password' }) passwordPlaceholder;
  @Prop({ type: String, default: 'Confirm Password' }) confirmPlaceholder;

  visible = false;
}
</script>
